import React from 'react';
import { Route } from 'react-router-dom';
import { QuizContainer } from './containers/QuizContainer';

export const routes = [<Route exact path="/quiz/:id" key="route--quiz" component={QuizContainer} />];
